import api from "../api" 
import router from "@/router"

const actions = {
     async fetchProjectList({ commit }) {
        try {
            const { data } = await api.get(`/project`)
            // //console.log("we got some project data", data)
            commit("projectMutation", data)
            return data
        } catch (error) {
            console.error("Error fetching projects:", error)
            throw error.data
        }
    },
    async fetchProject({commit}, {payload}){
        try{
            //console.log("[actions] fetchProject payload",typeof payload)
            const id = payload
            const { data } = await api.get(`/project/${id}`)
            //console.log("fetchproject :", data)
            commit("projectUniqueMutation", data)
            return data
        }catch(error){
            console.error("Error fetching a project", error)
            throw error.data;
        }
    },
    //TODO FIX IF ANYTHING'S BROKEN AS OF 2026.02.10
    async projectInsert({ commit }, payload) {
        try {
            //commit("loadingMutation", true)
            ////console.log("we got some project data", payload)
            const { data } = await api.post(`/project`, payload)
            // //console.log("we got some project data", data)
            commit("addProjectMutation", data)
            commit("selectProjectMutation", data.project_id)
            //commit("loadingMutation", false)
            router.push('/project/'+data.project_id+'/generalData')
            return data
        } catch (error) {
            console.error("Error inserting project:", error)
            throw error.data
        }
    },
    async projectUpdate({ commit }, payload) {
        try {
            //commit("loadingMutation", true)
            ////console.log("we got some project data", payload)
            // //console.log("testing what's inside payload", payload.payload.project_id)
            const { data } = await api.put(`/project/${payload.project_id}`, payload)
            ////console.log("we got some project data", data)
            commit("updateProjectMutation", data)
            commit("selectProjectMutation", data.project_id)
            //commit("loadingMutation", false)
            return data
        } catch (error) {
            console.error("Error updating project:", error)
            throw error.data
        }
    },
    async projectDelete({ commit }, { id, fromRef }) {
        try {
            //console.log("id:", id, "\nfromRef", fromRef)
            //console.log("testing what's inside payload", id)
            const { data } = await api.delete(`/project/${id}`,{ project_id:id })
             //console.log("we got some project data", data)
            commit("deleteProjectMutation", id)
            if(fromRef){
                 router.go();
            }else{
                commit("selectProjectMutation", 0)
                router.push(`/project`);
            }

            // commit("fetchCriteriaListForProject", data.id)
           return data
        } catch (error) {
            console.error("Error deleting project:", error)
            throw error.response?.data
        }
    },
    async fetchProductionReferentials({ commit }) {
        try {
            const { data } = await api.get(`/referentiel/production`)
            // //console.log("we got some referentials in pruduction", data)
            commit("productionReferentialsMutation", data)
            // //console.log("we got some referentials in pruduction", data)
            // if (data?.result && Array.isArray(data.result)) {
            return data
        } catch (error) {
            console.error("Error fetching projects:", error)
            throw error.response?.data
        }
    },

    async fetchProjectCriteriaList({ commit, state }, { id }) {
        try {
            const realId = id ? id : state.selectedProject
            const { data } = await api.get(`/project/${realId}/criteria`)
            //console.log("Data from criteria fetch: ", data)

            if(!realId){
                console.error("NO ID FETCHED, CHECK HANDLECLICK ")
                return;
            }
            
            if (data?.criteria && Array.isArray(data.criteria)) {
                if(data.criteria.length > 0) {
                    //console.log("tests passed, should load loadtreeMutation with values")
                    commit("loadTreeMutation", data.criteria)
                } else {
                    commit("loadTreeMutation", [])
                }
            } else {
                //console.log("No data in there ???")
                commit("loadTreeMutation", [])
            }
            if (data?.questions && Array.isArray(data.questions)) {
                if(data.questions.length > 0) {
                    // //console.log("tests passed, should load loadtreeMutation with values")
                    commit("loadTreeQuestionMutation", data.questions)
                } else {
                    commit("loadTreeQuestionMutation", [])
                }
            } else {
                // //console.log("No data in there");
                commit("loadTreeQuestionMutation", [])
            }
            commit("selectReferentialIDMutation", realId)
            
            return data
        } catch (error) {
            console.error("Error fetching criteria:", error)
            throw error.response?.data
        }
    },
    async fetchGeneralData({ commit }, { id }) {
        try {
            const { data } = await api.get(`/project/${id}/project_variables`)
            // //console.log("we got some general data", data)
            commit("generalDataMutation", data)
            return data
        } catch (error) {
            console.error("Error fetching general data:", error)
            throw error.response?.data
        }
    },
    updateGeneralData({ state, commit }, {tag, value, comment, type}) {
        //console.log("we got some general data", tag, value)
        if( type === "single") {
            try {
                api.put(`/project/${state.selectedProject}/project_variables/${tag}`, { value })
                    .then(response => {
                        // //console.log("General data updated successfully", response.data)
                        commit("updateGeneralDataArrayMutation", response.data)
                    })
                    .catch(error => {
                        console.error("Error updating general data:", error)
                    });
            } catch (error) {
                console.error("Error in updateGeneralData action:", error)
                throw error.response?.data;
            }
            // commit("updateGeneralDataMutation", {tag, value})
        } else if( type === "text") {
            try{
                api.put(`/project/${state.selectedProject}/project_variables/${tag}`, { comment })
                    .then(response => {
                        //console.log("I am in a TYPE TEXT", response.data)
                        commit("updateGeneralDataArrayMutation", response.data)
                    }).catch(error => {
                        console.error("FAILED TYPE TEXT", error)
                    })
            }catch(error){
                console.error("TYPE TEXT FAILED")
                throw error.response?.data;
            }
        }else if( type === "array") {
            try{
                api.put(`/project/${state.selectedProject}/project_variables/${tag}`, { values:value })
                    .then(response => {
                        //console.log("I am in a TYPE ARRAY1", response.data)
                        commit("updateGeneralDataArrayMutation", response.data)
                    }).catch(error => {
                        console.error("FAILED TYPE ARRAY2", error)
                    })
            }catch(error){
                console.error("TYPE ARRAY FAILED3")
                throw error.response?.data;
            }
        }else{
            try {
                api.put(`/project/${state.selectedProject}/project_variables/${tag}`, { values: value })
                    .then(response => {
                        // //console.log("General data updated successfully", response.data)
                        commit("updateGeneralDataArrayMutation", response.data)
                    })
                    .catch(error => {
                        console.error("Error updating general data:", error)
                    });
            } catch (error) {
                console.error("Error in updateGeneralData action:", error)
                throw error.response?.data;
            }
            // commit("updateGeneralDataMutation", {tag, value})
        }
    },
    async fetchProjectTeam({ state }, { id }) {
        try {
            const { data } = await api.get(`/project/${id}/project_team`)
            // //console.log("we got some project team data", data)
            state.projectTeam = data
            return data
        } catch (error) {
            console.error("Error fetching project team:", error)
            throw error.response?.data
        }
    },
    async updateProjectTeam({ state }, { row }) {
        try {
            // //console.log("we got some project team data to update", row)
            const { data } = await api.post(`/project/${state.selectedProject}/project_team/${row.entity_quality}`, row)
            // //console.log("we got some updated project team data", data)
            // No need to update. No state variable for now
            // commit("updateProjectTeamMutation", data)
            return data
        } catch (error) {
            console.error("Error updating project team:", error)
            throw error.response?.data
        }
    },
    async createProjectTeam({ state, commit }, {entity_quality, entity_address, entity_zip, entity_name, entity_surname, entity_tel, entity_mail}) {
        try {
            // //console.log("we got some project team data", entity_quality, entity_address, entity_zip, entity_name, entity_surname, entity_tel, entity_mail)
            const { data } = await api.post(`/project/${state.selectedProject}/project_team/${entity_quality}`,
                { 
                    entity_quality,
                    entity_address,
                    entity_zip,
                    entity_name,
                    entity_surname,
                    entity_tel,
                    entity_mail 
                })
            // //console.log("we got some project team data", data)
            commit("addProjectTeamMutation", data)
            return data
        } catch (error) {
            console.error("Error creating project team:", error)
            throw error.response?.data
        }
    },

    async fetchUserList({ commit, state }, { id }) {
        try {
            const { data } = await api.get(`/user/list`)
            const { data: data2 } = await api.get(`/project/${state.selectedProject}/users`)
            // //console.log("we got some data", data)
            // //console.log("we got some data2", data2)
            commit("userListMutation", data, id)
            commit("userListRightsProjectMutation", data2, id)
            return data
        } catch (error) {
            console.error("Error fetching Users for referential:", error)
            throw error.response?.data
        }
    },
    
    async toggleUserAccess({ commit, state }, { user, project_id, type, checked }) {
        // //console.log("user data received: ", user, project_id, type, checked)
        if(state.selectedProject == project_id) {
            try {
                if(!checked) {
                    const { data } = await api.put(`/project/${state.selectedProject}/revoke/${user.user_id}`, {
                        role: type
                    })
                    if(data.success == true) {
                        commit("updateUserAccessMutation", { user, type, checked })
                        // //console.log("User access revoked successfully", user, type, checked)
                    }
                    return data
                }
            } catch (error) {
                console.error("Error changing user access:", error)
                throw error.response?.data
            }
        }
    },

    async fetchAllAnswers({ commit, state }) {
    try{
        const id = state.selectedProject
        //Supposed to avoid request with 0 as the id 
        if(id != 0){
            const {data} = await api.get(`/project/${id}/answer`)
            /* commit("answerMutationTest", { result: data }) */
            // uncomment when the API is modified
            // //console.log("data.answers: ",data.answer)
            commit("answerMutationTest", { result: data.answer })
            commit("evaluationCriteriaMutation", { result: data.criteria_evaluations })
            commit("evaluationQuestionMutation", { result: data.question_evaluations })
            //commit("projectValidateMutation", {result : data.errors})
            // //console.log("Here's the CRITERIA EVALUATIONS: ", data.criteria_evaluations)
            //console.log("answerQTest DATA  !!!!!", state.answerQTest)
            return data
        }
        return
        }catch(error){
            console.error("Error fetching all answers:", error)
            throw error.response?.data
        } 
    },    
    async updateAnswer( {state, commit}, payload) {
        const id = state.selectedProject
        const questionId = payload.question_id
        try{
            const { data } = await api.put(`/project/${id}/answer/${questionId}`, payload)
            //console.log("data.answer = ",data, "\n", payload)
            //console.log("data.answerArray ",Array.isArray(data.answers), data.answers)
            commit("updateAnswerMutation", data.answer)
            commit("selectQuestionMutation", questionId)
            commit("evaluationCriteriaMutation", { result : data.criteria_evaluations })
            commit("evaluationQuestionMutation", {result : data.question_evaluations })
            /* commit("evaluationQuestionMutation", data.question_evaluations) */
            // //console.log("Here's the UPDATED      CRITIERIA EVALUATIONS: ", data.criteria_evaluations)
        }catch(error) {
          console.error("Error with updating Answers", error)
          throw error.response?.data
        }
    },

    async projectChangeStatus({ commit }, { id, status, fromRef }) {
        // async projectChangeStatus({ state, commit, rootState }, { id, status }) {
        // //console.log("Changing project status from id", id, " to", status)
        // //console.log("selected project data", state.projectData)
        // //console.log("selected project data", getters.filterActiveProject)
        try {
            // TODO: recheck everything here. something's off
            // if(rootState.auth.referentialDisplay || rootState.auth.isAdmin) {
                //     if( rootState.referential.numberProjects.filter( p => p.project_id == id).length == 0) {
                    //         console.error("User does not have rights to modify this project")
                    //         throw new Error("User does not have rights to modify this project")
                    //     } else {
                        //         //console.log("User has rights to modify this project")
                        //     }
                        // } else {
                            //     // If admin / ref creator, modify project even if not selected
                            //     if( id != state.selectedProject) {
                                //         console.error("Selected project ID does not match the provided ID")
                                //         throw new Error("Selected project ID does not match the provided ID")
                                //     }
                                // }
                                let payload = {
                                    project_id: id,
                                    status: status
                                }
            //console.log("fromRef", fromRef)
            const { data } = await api.put(`/project/${id}`, payload)
            // //console.log("we got some project data", data)
            commit("updateProjectMutation", data)
            if(!fromRef){
                commit("selectProjectMutation", data.project_id)
            }else{
                router.go();
            }
            
            return data
        } catch (error) {
            console.error("Error changing project status:", error)
            throw error.response?.data
        }   
    },
    async shareProject( { commit }, { payload }) {
        try {
            const code = payload.code
            const { data } = await api.post(`project/associate/${code}`)
            commit("shareProjectMutation", data)
            ////console.log("This is the data you have from sharging a project",data)
        }catch (error) {
            console.error("error with sharing project", error)
            throw error.response?.data
        }
    },
    async uploadFile({ state, commit, dispatch }, payload) {
        const projectId = state.selectedProject;
        //console.log("state.selectedQuestion :",state.selectedQuestion, "\tpayload.questionId :", payload.questionId)
        let questionId = payload.questionId ? payload.questionId : state.selectedQuestion; 
        const file = payload.file;
        const filename = file.name;
        const formData = new FormData();
        formData.append('file', file);

        try {
            const url = `project/${projectId}/files/${questionId}/${encodeURIComponent(filename)}`;
            const { data } = await api.put(url, formData);

            //console.log("File uploaded successfully:", data);
            commit("addFileMutation", data);
            await dispatch("getAllFiles");
            return data;

        } catch (error) {
            if(error.response?.status === 400){
                //console.log("Error uploading file :", error);
                alert(error.response?.data?.error ? error.response?.data?.error : error.response?.data?.errors)
            }
            //console.log("Error uploading file:", error);
            throw error.response?.data;
        }
    },
    async getAllFiles({ state, commit }) {
        const projectId = state.selectedProject;
        if (!projectId) return;

        try {
            const { data } = await api.get(`project/${projectId}/files-list`);
            commit("setAllFilesMutation", data);
            return data;
        } catch (error) {
            console.error("Error fetching files:", error);
            throw error.response?.data;
        }
    },
    async getFile({state, commit}, payload){
        try {
            const projectId = state.selectedProject
            const questionId = payload.question_id
            const { data } = await api.post(`project/${projectId}/files-by-ref/${questionId}`, payload, {
                responseType: 'blob'
            });
            // const fileBlob = data
            // //console.log(fileBlob);  
            // //console.log("Files fetched successfully get file", data)
            commit("getFileMutation", data)
            /* commit("getFilesMutation", data) */
            return data
        } catch (error) {
            console.error("Error fetching files:", error)
            throw error.response?.data
        }
    },
    //MO = ? 
    async getProjectRights({ commit, state }){
        const projectId = state.selectedProject
        ////console.log("GIVE ME THE PROJECTID",projectId)
        try{
            const { data } = await api.get(`user/project-rights/${projectId}`)
            ////console.log("Project rights fetched successfully", data.MO)
            commit("projectRightsMutation", data.MO)
        }
        catch(error){
            console.error("Error fetching project rights:", error)
            throw error.response?.data
        }
    },
    async projectDuplicate({ /*dispatch,*/ commit }, payload) {
        const { id, router, ...apiPayload } = payload
        //console.log("Payload pour l'API :", apiPayload)
        try {
            const { data } = await api.post(`/project/${id}/duplicate`, apiPayload)
            // //console.log("we got some data, like this:", data)
            // await dispatch('fetchProjectList')
            let newId = data.project_id
            // await dispatch("fetchProjectList")
            commit("addProjectMutation", data)
            commit("selectProjectMutation", newId)
            // //console.log("new id", newId)
            router.push(`/project/${newId}/generalData`)
            return data
        } catch (error) {
            console.error("Error duplicating project:", error)
            throw error.response?.data
        }
    },
    async flushProjectsAdmin(){
        try {
            const {data} = await api.post(`/project/flush`)
            //console.log("flushing all projects as an admin", data)
            return data;
        }catch(error){
            console.error("Error flushing projects:", error)
            throw error.response?.data
        }
    },
    async updateEvaluation({ commit, state }, payload) {
        const projectId = state.selectedProject
        const criteriaId = payload.criteria_id
        //console.log("Updating evaluation for project:", projectId, "criteria:", criteriaId)
        try {
            const { data } = await api.put(`/project/${projectId}/evaluation/${criteriaId}`, payload)
            // if()
            // //console.log("Evaluation updated successfully:", data)
            commit("updateEvaluationMutation", { data: data, criteriaId: criteriaId })
            //console.log("Is ther any impact from updateEvaluationMutation", data)
            return data
        } catch (error) {
            console.error("Error updating evaluation:", error)
            throw error.response?.data
        }
    },
    async fetchEvaluationData({ commit }, { projectId }) {
        ////console.log("Fetching evaluation data for project:", projectId);
        try {
            const { data } = await api.get(`/project/${projectId}/evaluations`);
            ////console.log("Evaluation data fetched successfully:", data);
            commit("setCriteriaEvaluation", { result: data });
            // commit("evaluationQuestionMutation", { result: data.question_evaluations });
            return data;
        } catch (error) {
            console.error("Error fetching evaluation data:", error);
            throw error.response?.data;
        }
    },  
    async fetchTagValues({commit, state}, payload){
        const projectId = state.selectedProject
        const tag = payload.tag
        const index = payload.index
        // //console.log("payload for tags : ",payload)
        try {
            const { data } = await api.get(`/project/${projectId}/result/${tag}/${index}`);
            //console.log("data tag :", data)
            //console.log(tag, "tag values", data);
            let valueToCommit;
            if ((data.result === null || data.result === undefined ) || data.errors.length>0 ){
                //console.log("FIRST CONDITION : ", )
                valueToCommit = data.errors[0]?.message || "Valeur en attente de calcul";
            }else if (!isNaN(data.result)){
                //console.log("SECOND CONDITION", data.result, data.errors)
                valueToCommit = data.result
            }else {
                //console.log("THIRD CONDITION",data.result, data.error)
                valueToCommit = data.errors[0]?.message || "Paramètre introuvable"
            }
            ////console.log("payload, valueData ", valueToCommit, "\n tag",payload)
            commit("fetchTagValues", {tag: payload.tag, data: valueToCommit});
            return data;
        }catch(error){
            console.error("Error fetching tag values");
            throw error.response?.data;
        }
    },
    async fetchReports({commit}, payload){
        const projectId = payload
        if (!payload) return;
        try{
            const { data } = await api.get(`project/${projectId}/reports`)
            //console.log("Reports = ", data);
            commit("fetchPDF", data)
        }catch(error){
            console.error("fetching pdf went wrong: ", error)
            throw error.response?.data;
        }
    },
    async createPDF({commit}, payload){
        const projectId = payload.id
        if(!payload) return;
        try{
            const { data } = await api.post(`project/${projectId}/report/${payload.type}`, null, {
                responseType: 'blob'
            })
            commit("createPDFMutation", data)
            return data;
        }catch(error){
            console.error("creating pdf went wrong", error)
            throw error.response?.data
        }
    },
    async fetchGraphData({commit}, projectId){
        // //console.log("Fetching graph data for project:", projectId);
        try {
            const { data } = await api.get(`/project/${projectId}/graph_data`);
            // //console.log("Graph data fetched successfully:", data);
            commit("setGraphData", data);
            return data;
        } catch (error) {
            console.error("Error fetching graph data:", error);
            throw error.response?.data;
        }
    },
    async projectValidate({commit, state}){
        try{
            const id = state.selectedProject
            const { data } = await api.get(`project/${id}/validate`)
            commit("projectValidateMutation", data)
            return data
        }catch(error){
            console.error("Couldn't load the ")
            throw error.response?.data;
        }
    },
    async deleteFile({commit, dispatch, state}, payload){
        try{
            const projectId = state.selectedProject ? state.selectedProject : payload.project_id
            const questionId = payload.question_id
            const timestamp = payload.timestamp
            const name = payload.name
            //console.log("delete file payload", payload)
            const { data } = await api.delete(`project/${projectId}/files-by-ref/${questionId}/${name}/${timestamp}`)
            //console.log("data reponses :",data)
            commit("addFileMutation", data);
            await dispatch("getAllFiles");
            commit("getFileMutation", data)
            /* commit("getFilesMutation", data) */
            return data
        }
        catch(error){
            console.error("Couldn't delete the file")
            throw error.response?.data;
        }
    },
}

export default actions;